import axios from "axios";
import {Modal} from "bootstrap";
import createSpinner from "../lib/create-spinner";

const resourceTabContainer = document.getElementById('resource-tab-container')
if (resourceTabContainer) {
    const modalElement = document.getElementById('resource-modal')

    async function loadResource(resourceUrl) {
        const modal = new Modal(modalElement)
        const modalBody = modalElement.getElementsByClassName('modal-body')[0]
        const modalTitle = modalElement.getElementsByClassName('modal-title')[0]
        modalTitle.innerText = ''
        modalBody.innerHTML = ''
        modalBody.appendChild(createSpinner())
        const response = await axios.get(resourceUrl)
        modalBody.innerHTML = response.data
        const header = modalBody.getElementsByTagName('h1')[0]
        modalTitle.innerText = header.innerText
        header.parentNode.remove()
        modal.show()
        const audioElement = modalElement.getElementsByTagName('audio')[0];
        if (audioElement) {
            modalElement.addEventListener('hide.bs.modal', () => {
                audioElement.pause()
            })
        }
    }

    async function loadResources(resourceUrl, targetElement) {
        targetElement.innerHTML = ''
        targetElement.appendChild(createSpinner())
        const response = await axios.get(resourceUrl)
        targetElement.innerHTML = response.data
        Array.from(targetElement.getElementsByClassName('page-link')).forEach(link => {
            link.addEventListener('click', evt => {
                evt.preventDefault()
                loadResources(link.href, targetElement)
            })
        })
        Array.from(targetElement.getElementsByClassName('view-resource-link')).forEach(link => {
            link.addEventListener('click', evt => {
                evt.preventDefault()
                loadResource(evt.target.href)
            })
        })
    }

    const tabs = resourceTabContainer.getElementsByClassName('tab-pane')
    Array.from(tabs).forEach(async function (tab) {
        loadResources(tab.dataset.resourceUrl, tab)
    })
}
